@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';

@border: var(--default--border-color--6) solid 1px;

.tagline {
  font-weight: 700;
}

.trial-tagline {
  padding: @space-16 0;
}

.long-form-description {
  margin-top: @space-16;
}

.name-and-price {
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-bottom: @border;
  padding-top: @space-16;
  padding-bottom: @space-16;
  align-items: center;

  .price {
    display: flex;
  }

  .amount {
    font-size: 20px;
    font-weight: 400;
    line-height: @space-24;
  }

  .per-month {
    line-height: @space-24;
  }
}

.bullets {
  font-size: 14px;
  line-height: @space-24;
  margin-left: @space-12;
  padding-left: 0;
  list-style-type: none;

  li {
    list-style-type: none;
    position: relative;
    padding-left: 5px;
    margin-left: 5px;
    padding-top: @space-16;
    width: 100%;
  }

  li:before {
    content: '\2713 ';
    position: absolute;
    left: -15px;
  }
}

.redirect-message-box {
  margin-top: @space-16;
  display: flex;
  flex-direction: column;
  padding: @space-12;
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 4px;
}

.redirect-text-icon {
  height: 12px;
  width: 12px;
  margin-left: @space-8;
}

.redirect-title-text {
  display: flex;
  align-items: center;
}

.redirect-title-icon {
  height: 16px;
  width: 16px;
  color: var(--blue-600);
  margin-right: @space-8;
}

.redirect-text {
  margin-top: @space-8;
  margin-left: @space-24;
}
